export default __webpack_public_path__ + "static/media/login.e8d1a453.jpeg";